<template>
  <v-container fluid>
    <v-snackbar v-model="messages" :vertical="true">
      {{ message }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="messages = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-app-bar flat color="accent-0" class="content-bar">
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-row>
      <v-col>
        <base-material-card color="#FFB058">
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              Profil
            </div>

            <div class="subtitle-1 font-weight-light">
              Compléter votre profil
            </div>
          </template>
          <br /><br />
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="user.data.firstName"
                    label="Prénom"
                    required
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="user.data.lastName"
                    label="Nom"
                    required
                    outlined
                    dense
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="user.data.university"
                    :items="[
                      'Aix Marseille',
                      'Amiens (Picardie Jules Verne)',
                      'Angers',
                      'Besançon (Franche-Comté)',
                      'Bordeaux',
                      'Brest',
                      'Caen',
                      'Chambéry',
                      'Grenoble',
                      'Lille 3',
                      'Lyon 2',
                      'Montpellier',
                      'Nancy 2',
                      'Nantes',
                      'Nice',
                      'Paris 5',
                      'Paris 8',
                      'Paris Nanterre',
                      'Poitiers',
                      'Reims',
                      'Rouen',
                      'Strasbourg',
                      'Toulouse 2',
                      'Tours',
                      'Autre ville Française',
                      'Canada',
                      'Belgique',
                      'Suisse',
                      'Luxembourg',
                      'Autre pays'
                    ]"
                    label="Dans quelle université avez-vous étudié ou étudiez-vous actuellement ?"
                    :rules="[rules.required]"
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="user.data.professionalStatus"
                    :items="[
                      'Neuropsychologue libéral',
                      'Neuropsychologue en institution',
                      'Enseignant chercheur en sciences cognitives/neuropsychologie',
                      'Doctorant',
                      'Étudiant en master 2 neuropsychologie'
                    ]"
                    label="Statut professionnel"
                    :rules="[rules.required]"
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="user.data.email"
                    label="E-mail"
                    required
                    disabled
                  ></v-text-field>
                </v-col>

                <!--    <v-col cols="12">
                  <v-text-field
                    v-model="password"
                    label="Mot de passe"
                    hint="Au moins 8 caractères"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    @click:append="show1 = !show1"
                    counter
                    :rules="[rules.min]"
                  ></v-text-field>
                </v-col> -->

                <v-col cols="12" class="text-right">
                  <v-btn class="mr-0" :disabled="!valid" @click="modify()">
                    Mettre à jour
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
    <br />
    <br />
    <v-row>
      <v-col cols="12" sm="8" md="4" lg="4">
        <base-material-stats-card
          color="#26B0E3"
          icon="mdi-file-document-multiple-outline"
          title="Nombre d'activités"
          :value="myActivities.length.toString()"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const firebase = require("../../firebase.config.js");

export default {
  name: "ConsultationActivitee",
  components: {},
  computed: {
    ...mapGetters({
      user: "user/getUser",
      firebaseUser: "user/firebaseUser",
      myActivities: "activities/getMyActivities"
    })
  },
  created() {
    this.id = this.$route.params.id;
  },
  methods: {
    ...mapActions({
      fetchUser: "user/fetchUser"
    }),
    updateProfile() {
      firebase.auth().currentUser.updateProfile({
        displayName: this.user.data.firstName + " " + this.user.data.lastName
      });
    },
    updateCustomDetails() {
      firebase.usersCollection.doc(firebase.auth().currentUser.email).update({
        firstName: this.user.data.firstName,
        lastName: this.user.data.lastName,
        university: this.user.data.university,
        professionalStatus: this.user.data.professionalStatus
      });
    },
    updateEmail() {
      firebase
        .auth()
        .currentUser.updateEmail(this.user.data.email.toLowerCase());
    },
    updatePassword() {
      firebase
        .auth()
        .currentUser.updatePassword(this.password)
        .then(() => {
          this.password = null;
        })
        .catch(error => alert("🤕" + error.message));
    },
    modify() {
      if (this.$refs.form.validate()) {
        this.updateProfile();
        this.updateCustomDetails();
        if (this.password) {
          this.updatePassword();
        }
        this.message = "Votre profil a été modifié";
        this.messages = true;
        this.fetchUser(firebase.auth().currentUser);
      }
    }
  },
  data: () => ({
    firebase: firebase.configOptions,
    password: "",
    valid: true,
    nameRules: [
      v => !!v || "Name is required",
      v => (v && v.length <= 10) || "Name must be less than 10 characters"
    ],
    rules: {
      required: value => !!value || "Ce champ est requis",
      min: v => (v && v.length >= 8) || "8 caractères minimum"
    },
    email: "",
    messages: false,
    message: "",
    show1: false,
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ]
  })
};
</script>
<style scoped>
img {
  width: 200px;
  height: 150px;
  border: 1px solid #000;
}

.contain {
  object-fit: contain;
}

.courseHeader {
  color: #fff;
  padding: 5px 0 0;
  line-height: 30px;
  background: #7451eb;
  margin-bottom: 16px;
  position: relative;
}

.grid-wrapper {
  margin: auto;
  max-width: 1280px;
  width: 100%;
}

.v-card.margin-card {
  border-radius: 6px;
  margin-top: 30px;
  margin-bottom: 15px;
}
img {
  border: 0px !important;
}
.frame {
  height: 150px; /* equals max image height */
  width: 160px;
  border: 1px cadetblue solid;
  white-space: nowrap;

  text-align: center;
  margin: 1em 0;
}
.subframe {
  height: 39px; /* equals max image height */
  width: 160px;
  border: 1px cadetblue solid;
  white-space: nowrap;

  text-align: center;
  margin: 1em 0;
}
.helper {
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}
</style>
